import Marquee from "react-fast-marquee";

const ITEMS = [
  "FOR RESEARCH USE ONLY",
  "NOT FOR HUMAN CONSUMPTION",
  "99%+ HPLC VERIFIED PURITY",
  "THIRD-PARTY LAB TESTED",
  "COA AVAILABLE UPON REQUEST",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-[#0A0A0A] py-5">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((t) => (
          <span key={t} className="mx-10 font-mono text-xs tracking-[0.3em] text-[#A3A3A3]">
            {t} <span className="ml-10 text-[#00ff72]">///</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
